import { getTooltips } from '@/lib/adapters/tooltip-adapter';
import { getApplicationSettings } from '@/lib/adapters/users-adapter';
import { applicationSettingsAtom, tooltipsAtom } from '@/lib/atoms/atoms';
import i18n from '@/lib/utils/i18n';
import { showNotification } from '@/lib/utils/showNotification';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

export const useAppSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const setTooltips = useSetAtom(tooltipsAtom);
  const setApplicationSettings = useSetAtom(applicationSettingsAtom);

  useEffect(() => {
    const loadData = async () => {
      const notifyError = (error: { message?: string }) =>
        showNotification(
          'error',
          error?.message || i18n.t('general.errors.unknown'),
        );

      await Promise.all([
        getTooltips().then(setTooltips).catch(notifyError),
        getApplicationSettings()
          .then(setApplicationSettings)
          .catch(notifyError),
      ]);
    };

    setIsLoading(true);
    loadData().finally(() => setIsLoading(false));
  }, [setApplicationSettings, setTooltips]);

  return isLoading;
};
